import {Component, Input, OnInit} from '@angular/core';
import {Order} from '../../../../../../back-office/Models/Order';
import {Router} from '@angular/router';
import {ServiceRequestService} from '../../../../../Services/service-request.service';
import {OrderService} from '../../../../../Services/order.service';

@Component({
  selector: 'app-dealer-reply-step-reorder',
  templateUrl: './dealer-reply-step-reorder.component.html',
  styleUrls: ['./dealer-reply-step-reorder.component.scss']
})
export class DealerReplyStepReorderComponent implements OnInit {
  @Input() Index;
  @Input() isActive;
  public replyItem;
  public order: Order = new Order();

  constructor(
    private requestService: ServiceRequestService,
    private router: Router,
    private orderService: OrderService
  ) {
  }

  ngOnInit() {
    this.requestService.serviceRequest.subscribe(serviceRequest => {
      if (serviceRequest.reply) {
        const replyItems = serviceRequest.reply.replyItems.filter(item => !item.solutionStep.restricted);
        this.replyItem = replyItems[this.Index];
        if (this.replyItem.replyReOrder && this.replyItem.replyReOrder.relatedOrder) {
          this.order = this.replyItem.replyReOrder.relatedOrder;
        }
      }
    });
  }

  goToOrder() {
    this.router.navigateByUrl('dealer-system/order/' + this.order.id + '/show');
  }

  openOrderPdfFile() {
    this.orderService.getPdf(this.order.id).subscribe(res => {});
  }
}
